export default __webpack_public_path__ + "static/media/slide-cell-4.9f7935bb.svg";